import { useMemo } from 'react'
import { getCharterFareClassPolicy, type CharterFareClassPolicyResult } from 'lib/charterFlights/charterOfferFareClassRestrictions'

export default function useCharterFareClassPolicy(
  offer: { campaignTags?: Array<string> } | undefined,
  rooms: Array<App.Occupants> | undefined,
): CharterFareClassPolicyResult {
  return useMemo(() => getCharterFareClassPolicy({
    campaignTags: offer?.campaignTags,
    occupancies: rooms,
  }), [offer?.campaignTags, rooms])
}
